import { Factory } from 'rosie';

Factory.define('AnswerPerformanceView');

Factory.define('AnswerPerformanceViewWithDefaults')
  .extend('AnswerPerformanceView')
  .attr('audienceId', 'exampleAudienceId')
  .attr('dateRange', '1d');
